// Who may see the LLM's reasoning behind a dangerous-waste eval.
//
// Admins only, for now. The intent is that authorized non-admin users get it too, granted
// through a user setting — when that setting exists, add it as one more clause here rather
// than at any call site, so every surface that shows the reason stays in agreement about
// who is allowed to see it.
export function canUserSeeLlmEvalReason(userData) {
    if (!userData) return false;
    // Truthy rather than strictly `=== true`, matching canUserAccessWasteReceiver and
    // canSeeRealActorNameForRecord: `isAdmin` comes verbatim off the user's Firestore
    // document, so a non-boolean value there must not make this gate disagree with every
    // other admin gate in the app.
    return Boolean(userData.isAdmin);
}
